import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextAlignmentRight20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconTextAlignmentRight20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17.25 5.5a.75.75 0 0 0 0-1.5H2.75a.75.75 0 0 0 0 1.5zm0 7a.75.75 0 0 0 0-1.5H2.75a.75.75 0 0 0 0 1.5zM18 8.25a.75.75 0 0 1-.75.75H6.75a.75.75 0 0 1 0-1.5h10.5a.75.75 0 0 1 .75.75M17.25 16a.75.75 0 0 0 0-1.5H6.75a.75.75 0 0 0 0 1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextAlignmentRight20);
